var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMenu = function SvgMenu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 20,
    viewBox: "0 0 25 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 1.57895C0 0.706919 0.479695 0 1.07143 0L23.9286 0C24.5203 0 25 0.706919 25 1.57895C25 2.45098 24.5203 3.15789 23.9286 3.15789H1.07143C0.479695 3.15789 0 2.45098 0 1.57895Z",
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 10.0008C0 9.12879 0.479695 8.42188 1.07143 8.42188H23.9286C24.5203 8.42188 25 9.12879 25 10.0008C25 10.8729 24.5203 11.5798 23.9286 11.5798H1.07143C0.479695 11.5798 0 10.8729 0 10.0008Z",
    fill: "#333333"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 18.4195C0 17.5475 0.479695 16.8406 1.07143 16.8406H23.9286C24.5203 16.8406 25 17.5475 25 18.4195C25 19.2916 24.5203 19.9985 23.9286 19.9985H1.07143C0.479695 19.9985 0 19.2916 0 18.4195Z",
    fill: "#333333"
  })));
};
export default SvgMenu;